import { CSSObject } from '@chakra-ui/react';

export const TextFormInfo: CSSObject = {
  color: 'gray.600',
  fontWeight: 'medium',
};
